import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';
import 'jquery.qrcode';
import { AlertService } from '../../../providers/alert.service';
import { NormalReportService } from '../../../services/normalreport.service';
import { AppConfig } from '../../app.config';
import { OrderDetailModel } from '../../../models/orderdetail.model';
import { StorageService } from '../../../providers/storage.service';
import { MyObserverService } from '../../../services/myobject.service';

@Component({
    selector: 'order-detail',
    template: require('./orderdetail.html'),
    styles: [require('./orderdetail.scss')],
    providers: [NormalReportService]
})
export class OrderDetailComponent {
    @Input('orderId') orderId: any;
    @Input('orderType') orderType: any;
    @Input('displayText') displayText = '';
    @Output() event = new EventEmitter();
    storageTheme;
    display: boolean = false;
    order: OrderDetailModel = new OrderDetailModel();
    issueinfo = { BettingMoney: 0, PerPrice: 0, Multiple: 0 };
    medians = '';
    reward: number;
    BuyCount: number;
    colorArr: Array<string> = [];
    checkedArr: Array<boolean> = [];
    zodiacArr = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'];
    /**
     *下标对应生肖对象
     * @memberof LotteryComponent
     */
    numZodiacArr = {};

    /**
     *下标对应上一年生肖对象
     * @memberof LotteryComponent
     */
    numZodiacLastArr = {};

    /**
     *当前年份起始期号
     * @memberof LotteryComponent
     */
    beginIssue: number;

    constructor(
        private alert: AlertService,
        private normalreport: NormalReportService,
        private config: AppConfig,
        private storage: StorageService,
        private myobserver: MyObserverService
    ) {
        this.beginIssue = AppConfig.beginIssue;
        setTimeout(() => {
            this.beginIssue = AppConfig.beginIssue;
        }, 5000);
        let T1 = setInterval(() => {
            if (AppConfig.numZodiacLastArr) {
                clearInterval(T1);
                this.numZodiacLastArr = AppConfig.numZodiacLastArr;
            }
        }, 200);
        let T2 = setInterval(() => {
            if (AppConfig.numZodiacArr) {
                clearInterval(T2);
                this.numZodiacArr = AppConfig.numZodiacArr;
            }
        }, 200);
    }
    ngOnInit() {
        // this.getIssue();
        this.myobserver.styleModel.subscribe(s => {
            this.getThemes(s);
        });
    }
    /**
     * @params 监听主题更改
     * @param 当 Angular 初始化完组件视图及其子视图之后调用。
     * @param author David 2019--
     */
    ngAfterViewInit() {
        this.storageTheme = this.storage.read('theme');
        if (this.storageTheme) {
            this.getThemes(this.storageTheme);
        }
    }
    getThemes(theme) {
        if (!document.getElementsByClassName('zst_lhs')) {
            return;
        }
        switch (theme) {
            case 'day':
                $('.ant-modal').removeClass('night-theme');
                $('.ant-modal').addClass('day-theme');
                break;
            case 'night':
                $('.ant-modal').removeClass('day-theme');
                $('.ant-modal').addClass('night-theme');
                break;
            case 'help':
                $('.ant-modal').removeClass('night-theme');
                $('.ant-modal').addClass('day-theme');
                break;
            default:
                $('.ant-modal').removeClass('night-theme');
                $('.ant-modal').addClass('day-theme');
                break;
        }
    }

    //用户名 撤单判断用户名是否正确
    username = this.config.getCurrentUser().UserName;

    show() {
        this.display = true;
        this.getOrderDetail();
    }
    handleCancel() {
        this.display = false;
    }
    handleOk() {
        this.display = false;
    }

    //获取订单详情
    //TQQ 2017-01-02
    getOrderDetail() {
        // this.alert.Loading();
        this.checkedArr = [];
        return this.normalreport
            .getOrderDetail(this.orderId, this.orderType)
            .catch(() => {
                this.alert.CloseLoading();
            })
            .then(s => {
                if (s) {
                    s.IssueNo = Number(s.IssueNo);
                    if (s.BettingInfoIssues) {
                        s.BettingInfoIssues.forEach(element => {
                            element.IssueNo = Number(element.IssueNo);
                        });
                    }
                    this.order = s;
                    //中奖样式
                    // if (this.orderType == 1 /* &&s.LotteryCode == '95000' */) {
                    //     JSON.parse(this.order.BettingInfoIssues[0].BettingItems).forEach(element => {
                    //         if (element['Reward'] > 0)
                    //             this.checkedArr.push(true);
                    //         else
                    //             this.checkedArr.push(false);
                    //     });
                    // }
                }

                if (this.orderType == 0) {
                    this.issueinfo = s.Issues[0];
                    this.selectMedianName();
                    this.rewardModel();
                } else {
                    if (s.LotteryPlayModeTypeCode == 4 || s.LotteryPlayModeTypeCode == 5) {
                        s.BettingItems.forEach(element => {
                            var number = element.Position.split(',');
                            element.Position = [];
                            for (var i = 0; i < number.length; i++) {
                                number.splice(i, 1, this.fontPosition(number[i]));
                            }
                            element.Position = number;
                        });
                    }
                    this.BuyCount = this.order.BettingItems.length;
                }
            });
    }
    //二字定位，三字定位位置代号
    fontPosition(attr) {
        switch (attr) {
            case '0':
                return '万';
            case '1':
                return '千';
            case '2':
                return '百';
            case '3':
                return '十';
            case '4':
                return '个';
        }
    }
    //奖金模式
    //TQQ  2017-05-08
    rewardModel() {
        let sysconfig = this.config.getSysConfig();
        let lottery = this.config
            .getLotteryAll()
            .find(s => s.LotteryCode == this.order.LotteryCode);
        let rewardUp = lottery.RewardUp ? lottery.RewardUp : sysconfig.RewardUp;
        var baseReward = sysconfig.BasicReward + (rewardUp - sysconfig.RewardUp);
        this.reward = this.order.GraduationCount * sysconfig.PerGraduation + baseReward;
        this.BuyCount =
            this.issueinfo.BettingMoney / this.issueinfo.PerPrice / this.issueinfo.Multiple;
    }

    //选位
    //TQQ  2017-05-08
    selectMedianName() {
        let result = [];
        let m1;
        if (this.order.LotteryTypeCode === '02') m1 = ['一位', '二位', '三位', '四位', '五位'];
        else if (this.order.LotteryTypeCode === '08')
            m1 = [
                '第1名',
                '第2名',
                '第3名',
                '第4名',
                '第5名',
                '第6名',
                '第7名',
                '第8名',
                '第9名',
                '第10名'
            ];
        else m1 = ['万位', '千位', '百位', '十位', '个位'];
        // if (this.order.LotteryTypeCode === "02") {
        // }
        if (this.order.LotteryTypeCode === '03') {
            m1 = ['个位', '十位', '百位', '千位', '万位'];
            var j = m1.length - this.order.SelectMedian.length;
            for (var i = 0; i <= j; i++) {
                if (this.order.SelectMedian[i] === '1') {
                    result.push(m1[j - i]);
                }
            }
        } else {
            for (var i = 0; i < this.order.SelectMedian.length; i++) {
                if (this.order.SelectMedian[i] == '1') {
                    result.push(m1[i]);
                }
            }
        }
        this.medians = result.join('、');
    }
    //打印订单
    DaYinDingDan(e) {
        var that = this;
        var DingDaiDaYin = $(e.currentTarget)
            .parents('.ui-dialog')
            .find('.YouXiJiLuXingQing')
            .html();
        var copyhtml = $(
            '<div calss="DaYinNeiRong"><style>.YouXiJiLuXingQing{max-width:300px;width:90%;margin:0 auto;font-size:12px;}.YouXiJiLuXingQing p {clear: both;text-align:left;overflow: hidden;}.YouXiJiLuXingQing p span.k {width: 40%;}.YouXiJiLuXingQing p span.v {width: 60%;word-wrap:break-word;word-break:break-all;}.YouXiJiLuXingQing p span {float: left;line-height: 25px;}.YouXiJiLuXingQing textarea {width: 100%;border: 1px solid #ddd;padding:10px;height:auto;margin-top: 5px;padding: 5px}</style><div class="YouXiJiLuXingQing" style="text-align:center;overflow: hidden; padding-bottom: 10px;margin-bottom: 10px;margin-top: 10px;">\
            <p>\
                <span class="k">彩种：</span><span class="v">' +
                that.order.LotteryName +
                '</span>\
                <span class="k">期号：</span><span class="v">' +
                that.order.IssueNo +
                '</span>\
            </p>\
            <p>\
                <span class="k">玩法：</span><span class="v">' +
                that.order.PlayName +
                '</span>\
                <span class="k">金额：</span><span class="v">' +
                that.order.BettingMoney +
                '&nbsp;元</span>\
            </p>\
            <p>\
                <span class="k">购买时间：</span><span class="v">' +
                that.order.AddTime +
                '</span>\
            </p>\
            <p>\
                <span class="k">购买号码：</span><span class="v">' +
                that.order.BettingNumber +
                '</span>\
            </p>\
            <p>\
                <span class="k">投注总金额：</span><span class="v">' +
                that.order.BettingMoney +
                '&nbsp;元</span>\
            </p>\
            </div></div>'
        );
        // var $v = $('<div style="text-align:center;width: 110px;height: 110px;margin: 0 auto;background:#fff;padding:5px;" id="erweima"></div>');
        // var v = $v[0];
        // var qrcode = new QRCode(v, {
        //     width : 100,
        //     height : 100
        // });
        var local = 'http://wap.goodxb.com';
        $('.Dow_url').html(local);
        // var $w = $(v)
        var body = $('body>*').detach();
        $('body')
            .addClass('heightauto')
            .empty()
            .append(copyhtml);
        $('textarea').hide();
        $('.textareaDingDan').html($('textarea').text());
        // $('body').addClass('heightauto');
        setTimeout(function() {
            window.print();
            $('body')
                .removeClass('heightauto')
                .empty()
                .append(body);
            // $(v).qrcode.clear();
        }, 1000);
    }
    //撤单回调
    //TQQ 2017-02-23
    callback = () => {
        this.getOrderDetail();
        this.event.emit(1);
    };
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/shared/orderdetail/orderdetail.directive.ts